import { useEffect, useRef, useCallback } from "react";
export function useDebouncedCallback(callback, wait, deps) {
    const argsRef = useRef();
    const timeout = useRef();
    function cleanup() {
        if (timeout.current) {
            clearTimeout(timeout.current);
        }
    }
    useEffect(() => cleanup, []);
    return useCallback((...args) => {
        argsRef.current = args;
        cleanup();
        timeout.current = setTimeout(() => {
            if (argsRef.current) {
                callback(...argsRef.current);
            }
        }, wait);
    }, deps);
}
